import type { SemanticICONS } from 'semantic-ui-react'

declare global {
  interface Window {
    __CONFIG__: {
      environment: string
      apiUrl: string
      wsUrl: string
      authDomain: string
      authClientId: string
      stripeKey: string
      gitHubAppInstallUrl: string
      slackClientId: string
      jiraClientId: string
      growthbookClientKey: string
      googleAnalyticsId: string
    }
  }
}

export const EMPTY_OBJECT = Object.freeze({})
export const EMPTY_ARRAY = Object.freeze([])
export const IDENTITY_FUNC = (x) => x
export const EMTPY_FUNC = () => null
export const TRUE_FUNC = () => true

const ENVIRONMENT = window.__CONFIG__.environment
export const IS_PROD = ENVIRONMENT === 'prod'
export const IS_DEV = ENVIRONMENT === 'dev'
export const IS_LOCAL = ENVIRONMENT === 'local'
export const IS_NOT_PROD = !IS_PROD
export const RUNNING_LOCALLY = window.location.host.includes('localhost')

export const API_URL = window.__CONFIG__.apiUrl
export const WS_URL = window.__CONFIG__.wsUrl
export const AUTH_DOMAIN = window.__CONFIG__.authDomain
export const AUTH_CLIENT_ID = window.__CONFIG__.authClientId
export const STRIPE_KEY = window.__CONFIG__.stripeKey
export const GIT_HUB_APP_INSTALL_URL = window.__CONFIG__.gitHubAppInstallUrl
export const SLACK_CLIENT_ID = window.__CONFIG__.slackClientId
export const JIRA_CLIENT_ID = window.__CONFIG__.jiraClientId
export const GROWTHBOOK_CLIENT_KEY = window.__CONFIG__.growthbookClientKey
export const GOOGLE_ANALYTICS_ID = window.__CONFIG__.googleAnalyticsId

export const Icons = {
  testRuns: 'tasks' as SemanticICONS,
  project: 'folder outline' as SemanticICONS,
  workflow: 'fork' as SemanticICONS,
  testPlan: 'clipboard list' as SemanticICONS,
  alert: 'bell outline' as SemanticICONS,
  environment: 'server' as SemanticICONS,
  settings: 'settings' as SemanticICONS,
  triggers: 'clock outline' as SemanticICONS,
  dashboard: 'dashboard' as SemanticICONS,
  pipelines: 'th' as SemanticICONS,
  delete: 'trash' as SemanticICONS,
  edit: 'edit' as SemanticICONS,
  run: 'play' as SemanticICONS,
  threeDotMenu: 'ellipsis vertical' as SemanticICONS,
  terminal: 'terminal' as SemanticICONS,
  image: 'image outline' as SemanticICONS,
  video: 'video play' as SemanticICONS,
  stethoscope: 'stethoscope' as SemanticICONS,
  history: 'history' as SemanticICONS
}

export const UPLOAD_ARTIFACTS_HELP_URL =
  'https://docs.testery.io/testery-integration/testery-cli-docs#upload-build-artifacts'
export const TESTNG_HELP_URL = 'https://app.gitbook.com/@testery/s/testery/framework-specific-guidance/testng'
export const DYNAMIC_ENV_HELP_URL = 'https://docs.testery.io/get-to-know-testery/test-plans#add-test-suites-to-stage'
